module.exports = __webpack_public_path__ + "img/OpenSans-Italic.9f9bccfd.svg";